<template>
	<div class="editor">
		<title>{{data.title}}</title>
		<div v-html="data.config_value" style="margin:5px 10px;"></div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				data:'',
			}
		},
		mounted() {
			let self=this
			self.$store.dispatch('post',{u:'/rich_cext_config/dev_use_service_instruct',d:{user_id:self.$route.params.user_id,dev_id:self.$route.params.dev_id}}).then(function(res){
		    	if(res.err==0){
		    		self.data=res.data
					return
		    	}
			})
		}
	}
</script>
<style scoped>
	p{
		text-align:justify;
	}
</style>
<style>
	.editor img{
		margin: 0 auto;
		max-width: 80%;
	}
</style>


// WEBPACK FOOTER //
// src/views/instruction.vue